var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_317_1295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58867 0 0 3.58867 0 8C0 12.4113 3.58867 16 8 16C12.4113 16 16 12.4113 16 8C16 3.58867 12.4113 0 8 0ZM8 14.6667C4.324 14.6667 1.33333 11.676 1.33333 8C1.33333 4.324 4.324 1.33333 8 1.33333C11.676 1.33333 14.6667 4.324 14.6667 8C14.6667 11.676 11.676 14.6667 8 14.6667ZM10.6667 9.33333C10.6667 10.436 9.76933 11.3333 8.66667 11.3333V12C8.66667 12.3687 8.36867 12.6667 8 12.6667C7.63133 12.6667 7.33333 12.3687 7.33333 12V11.3333H7.15467C6.44333 11.3333 5.77933 10.9507 5.42267 10.334C5.238 10.0147 5.34733 9.60733 5.66533 9.42333C5.98467 9.23733 6.39267 9.348 6.576 9.666C6.69533 9.87267 6.91667 10 7.154 10H8.666C9.034 10 9.33267 9.70133 9.33267 9.33333C9.33267 9.08133 9.152 8.868 8.90333 8.82667L6.876 8.48867C5.98133 8.34 5.33267 7.57333 5.33267 6.66667C5.33267 5.564 6.23 4.66667 7.33267 4.66667V4C7.33267 3.632 7.63067 3.33333 7.99933 3.33333C8.368 3.33333 8.666 3.632 8.666 4V4.66667H8.84467C9.556 4.66667 10.22 5.05 10.5767 5.66667C10.7613 5.98533 10.652 6.39267 10.334 6.57733C10.014 6.762 9.60667 6.65267 9.42333 6.334C9.304 6.128 9.08267 6.00067 8.84533 6.00067H7.33333C6.96533 6.00067 6.66667 6.3 6.66667 6.66733C6.66667 6.91933 6.84733 7.13267 7.096 7.174L9.12333 7.512C10.018 7.66067 10.6667 8.42733 10.6667 9.334V9.33333Z",
    fill: "#FF6666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_317_1295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingActive);
export default __webpack_public_path__ + "static/media/PricingActive.38b3ec3a896fac46351b2e6172b38cda.svg";
export { ForwardRef as ReactComponent };